import StaffSelect from './src/staff-select';

export default StaffSelect;
